"use strict";

const MuniCleanoutGeoServerLayer = function () {
  const layerName = "muniCleanout";
  const layerKey = "muniCleanoutLayer";

  var createMarkerFunction = function (feature, latlng) {
    return L.marker(latlng, {
      icon: createIcon(feature.properties.icon.class),
    });
  };

  var createIcon = function (iconClass) {
    const currentZoomLevel = Tree.get("zoomLevel");
    const currentDataView = Tree.get("dataView");
    const iconSizesArray = [8, 17, 17, 48, 48, 48, 48, 48];
    const updatedIconSize = MapFunctions.resizeIconsOnZoom(
      currentZoomLevel,
      false,
      false,
      false,
      false,
      iconSizesArray,
    );
    return L.divIcon({
      iconSize: currentDataView === "muni-cleanout" ? updatedIconSize.size : [24, 24],
      popupAnchor: [0, 5],
      className: iconClass,
    });
  };

  var getUnsavedIconMarker = function () {
    return createIcon(RoutineMaintenanceIcon.getMaintenanceIcon("muni-cleanout", null).class);
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const muniCleanoutGeoServerLayer = new GeoServerMapLayer(
      layerName,
      layerKey,
      createMarkerFunction,
    );
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, muniCleanoutGeoServerLayer);

    muniCleanoutGeoServerLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    muniCleanoutGeoServerLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await GeoServerLayerFunctions.getFeaturesForLayer(
      layerName,
      onlineFiltering,
      loadingScreen,
    );
    return organizeMuniLayerData(data);
  };

  var organizeMuniLayerData = function (layerData) {
    return layerData.map(function (data) {
      return getOrganizedProperties(data.properties, data.geometry);
    });
  };

  var getOrganizedProperties = function (data, geometry) {
    return {
      id: data.id,
      groupId: data.group_id,
      geometry: geometry,
      name: data.name,
      type: data.type,
      address: data.address,
      cof: data.cof_final_text,
      coverShape: data.cover_shape,
      coverType: data.cover_type,
      phase: data.phase,
      landOwnership: data.property,
      implementerType: data.implementer_type,
      maintainedBy: data.responsible_party_maintenance,
      installDate: data.install_date,
      correctiveAction: JSON.parse(data.corrective_actions),
      enforcementLevel: JSON.parse(data.severity),
      condition: data.condition,
      icon: RoutineMaintenanceIcon.getMaintenanceIcon("muni-cleanout", data.condition),
      cleanoutDiameter: data.diameter,
      cleanoutDiameterUnits: data.diameter_units,
      cleanoutLength: data.length,
      cleanoutLengthUnits: data.length_units,
      cleanoutWidth: data.width,
      cleanoutWidthUnits: data.width_units,
      catchment_name: data.catchment_name,
      drains_to_rw: data.drains_to_rw,
      drains_to_c: data.drains_to_c,
      zone_names: data.zone_names,
      routine: DateTime.parseJsonIsoDateArray(data.routine_inspection_dates),
      repair: DateTime.parseJsonIsoDateArray(data.repair_dates),
    };
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    getLayerData,
    invalidateLayerData,
    organizeMuniLayerData,
    getUnsavedIconMarker,
  };
};

module.exports = MuniCleanoutGeoServerLayer();

const GeoServerLayerFunctions = require("../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../mapFunctions/geoServerMapLayer");
const MapFunctions = require("../mapFunctions/mapFunctions");
const RoutineMaintenanceIcon = require("../general/routineMaintenanceIcon");
const Tree = require("../tree");
const DateTime = require("../dateTime");
